var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayLaterCel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 111,
    viewBox: "0 0 110 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.81 55.3702C4.81 83.0563 27.3238 105.57 55 105.57C82.6762 105.57 105.19 83.0563 105.19 55.3702C105.19 27.694 82.6761 5.18018 55 5.18018C27.3239 5.18018 4.81 27.694 4.81 55.3702ZM0.809998 55.3702C0.809998 25.4463 25.0662 1.18018 55 1.18018C84.9338 1.18018 109.19 25.4463 109.19 55.3702C109.19 85.304 84.9239 109.56 55 109.56C25.0661 109.56 0.809998 85.304 0.809998 55.3702Z",
    fill: "#15264C",
    stroke: "#15264C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M54.92 11.5303V19.2303",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.12 17.3701L36.96 24.0401",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.15 33.3403L23.82 37.1804",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.31 55.1401H19.01",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.15 76.9501L23.82 73.1001",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.12 92.9102L36.96 86.2402",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M54.92 98.7505V91.0605",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M76.73 92.9102L72.88 86.2402",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M92.69 76.9501L86.02 73.1001",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M98.53 55.1401H90.83",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M92.69 33.3403L86.02 37.1804",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M76.73 17.3701L72.88 24.0401",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M36.96 37.1802L54.92 60.2701L70.31 47.4501",
    stroke: "#15264C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayLaterCel);
export default __webpack_public_path__ + "static/media/pay-later-cel.c3c26e309a1f86afbb7205710b2ad027.svg";
export { ForwardRef as ReactComponent };